import * as tslib_1 from "tslib";
import { Base } from "../base-component";
import "./form-item-business-solar-loan.component.scss";
import * as $ from "jquery";
import "bootstrap-datepicker";
var MaxLoanAmount = 500000;
var FormItemBusinessSolarLoan = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessSolarLoan, _super);
    function FormItemBusinessSolarLoan(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.sbcustomer = "";
        _this.sbPrefSupplier = "";
        _this.dataChecks = true;
        _this.map = new Map();
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.iSstep3Completed = false;
        _this.errors = [];
        _this.emptyerrors = [];
        return _this;
    }
    FormItemBusinessSolarLoan.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.businessType = this.element.querySelector(".js-business-type");
        this.loanPurpose = this.element.querySelector(".js-loan-purpose");
        this.loanAmount = this.element.querySelector(".js-loan-amount");
        this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.stepNo = this.element.querySelector(".form-container-wizard__stepno");
        this.sbAccountNumber = this.element.querySelector(".js-sb-account-number");
        this.isSBCustomer = this.element.querySelector(".js-sb-customer-radio-group");
        this.formDatePicker = this.element.querySelector(".js-date-picker");
        this.formTimePicker = this.element.querySelector(".js-time-picker");
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        // this.stepButtons = Array.from(this.element.querySelectorAll(".js_next-step-button"));
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.step1Button = this.element.querySelector(".js_next-step1-button");
        this.step2Button = this.element.querySelector(".js_next-step2-button");
        this.showStep(1);
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll(".js-sb-customer-radio-group"));
        this.sbPreferredSupplierToggle = Array.from(this.element.querySelectorAll(".js-sb-pref-supp-radio-group"));
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
            this.displayDecline = this.form.querySelector(".form-container__declined");
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea =
            this.element.querySelector(".data-sharing-sms");
        this.relPartiesHideBtn = this.element.querySelector(".data-rel-parties-hide-btn");
        this.relPartiesShowBtn = this.element.querySelector(".data-rel-parties-show-btn");
        this.relPartiesContent = this.element.querySelector(".data-rel-parties-content");
        //Analytics
        this.form.setAttribute("data-frmcontainer", "business solar loan | personal details");
        this.analyticsService.startDtmApplication("application: borrow for your needs | business solar loan", "business solar loan");
        this.updatePageName("step 1 personal details form");
        //calender
        this.publicHolidays = [
            "2018/01/01",
            "2018/03/21",
            "2018/03/30",
            "2018/04/02",
            "2018/04/27",
            "2018/05/01",
            "2018/06/16",
            "2018/08/09",
            "2018/09/24",
            "2018/12/16",
            "2018/12/17",
            "2018/12/25",
            "2018/12/26",
        ];
        this.populateDatePicker();
    };
    FormItemBusinessSolarLoan.prototype.validateLoanAmount = function (type) {
        //console.log(type);
        this.errors = [];
        var loanAmountfield = this.form.querySelector("input[name=loan-amount]");
        var _purposeOfLoan = this.form.querySelector("select[name=loan-purpose]");
        var amount = loanAmountfield.value;
        if (amount == 0 || amount == 0.00) {
            var form_group = $(loanAmountfield).closest(".form__group");
            form_group.addClass("form__group--error");
            this.errors.push("This field is required");
            this.addErrorMessage(loanAmountfield, this.errors);
        }
        else if (amount > MaxLoanAmount) {
            var form_group = $(loanAmountfield).closest(".form__group");
            form_group.addClass("form__group--error");
            this.errors.push("Loan amount should not exceed R500K");
            this.addErrorMessage(loanAmountfield, this.errors);
        }
        else {
            var _parent = loanAmountfield.closest(".form__group");
            if (_parent) {
                //_parent.removeClass('form__group--error');
                loanAmountfield
                    .closest(".form__group")
                    .classList.remove("form__group--error");
                var _errorDiv = _parent.querySelector(".form__group--error_message");
                if (_errorDiv) {
                    _errorDiv.remove();
                }
            }
        }
    };
    FormItemBusinessSolarLoan.prototype.addErrorMessage = function (pElement, pMessages) {
        var _parent = pElement.closest(".form__group");
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_1 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_1.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_1);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
        }
    };
    // populating the current date picker
    FormItemBusinessSolarLoan.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker("setStartDate", this._startDate);
        }
    };
    FormItemBusinessSolarLoan.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ""; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== "") {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() +
                "/" +
                _selectedDate.getMonth() +
                "/" +
                _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() +
                "/" +
                _currentDateTime.getMonth() +
                "/" +
                _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if (_currentMin >= 30 && _currentHour <= 15) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentMin >= 30 && _currentHour >= 15) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() +
            "/" +
            ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate =
                        _currentDateTime.getFullYear() +
                            "/" +
                            ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) +
                            "/" +
                            ("0" + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = _currentHour >= 10
            ? _currentHour + ":00:00"
            : "0" + _currentHour + ":00:00";
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== "Anytime") {
                if (item.options[i].value < _tmpTime &&
                    _enabledOptions === false) {
                    item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    FormItemBusinessSolarLoan.prototype.bindEvents = function () {
        var _this = this;
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        //loan purpose drop down
        if (this.loanPurpose) {
            this.loanPurpose.addEventListener("change", function () {
                return _this.validateLoanAmount("change");
            });
        }
        if (this.loanAmount) {
            this.loanAmount.addEventListener("blur", function () {
                return _this.validateLoanAmount("blur");
            });
        }
        //Calender
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener("change", function (event) {
                _this.validateDate(event.target);
            });
        }
        //Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step1");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep1Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep1Completed = true;
                    _this.dtmVirtualPage("step 2 business details form");
                    _this.showStep(2);
                }
            });
        }
        //Step 2 Next Button
        if (this.step2Button) {
            //debugger;
            this.step2Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step2");
                var formFields = _form.querySelectorAll("input:not(.solarloan_busreg_trust_input):not(.solarloan_busreg_other_input), select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                var formFieldsTrustOther = _form.querySelectorAll("#business-reg-number-trust, #business-reg-number-other");
                _this.validate(formFieldsTrustOther);
                var validTrustOther = Array.from(_form.querySelectorAll(".form__group--error"));
                var _authorityToApply = _form.querySelector("input[name=permission-act]:checked");
                var _legallyEnterContracts = _form.querySelector("input[name=legal-contracts]:checked");
                var _existingBounceBackLoan = _form.querySelector("input[name=solar-loan]:checked");
                var _debtReview = _form.querySelector("input[name=debt-review]:checked");
                var _declineReasons = _this.element.querySelector(".js-decline-reasons-list");
                _this.map.clear();
                _this.dataChecks = true;
                if (valid.length === 0 && validTrustOther.length === 0) {
                    if (_authorityToApply && _authorityToApply.value === "NO") {
                        _this.dataChecks = false;
                        _this.map.set("Authority", "Permission to act on behalf of the entity");
                    }
                    if (_legallyEnterContracts && _legallyEnterContracts.value === "NO") {
                        _this.dataChecks = false;
                        _this.map.set("Legal", "Legally enter into contracts");
                    }
                    // if (_existingBounceBackLoan && _existingBounceBackLoan.value === 'YES') {
                    // 	this.dataChecks = false;
                    // 	this.map.set('ExistingLoan', 'Business solar loan with Standard bank or any other institute');
                    //  }
                    if (_debtReview && _debtReview.value === "YES") {
                        _this.dataChecks = false;
                        _this.map.set("DebtReview", "Debt review");
                    }
                    _declineReasons.innerHTML = "";
                    _this.map.forEach(function (value, key) {
                        var li = document.createElement("li");
                        li.innerHTML = value;
                        _declineReasons.appendChild(li);
                    });
                    if (!_this.dataChecks) {
                        _this.showDisplayView("decline");
                        window.scrollTo(0, 0);
                    }
                    else {
                        _this.count += 1;
                        if (!_this.iSstep2Completed && !dataLayer.formisSubmitted)
                            _this.analyticsService.dtmFormComplete("complete", "", true);
                        _this.iSstep2Completed = true;
                        _this.dtmVirtualPage("step 3 loan details form");
                        _this.showStep(3);
                    }
                }
            });
        }
        //Step 3 Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step3");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                _this.validateLoanAmount();
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_this.form);
                }
            });
        }
        //Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.businessType) {
            this.businessType.addEventListener("change", function () {
                return _this.validateBusinessType("validate");
            });
        }
        this.modifiersRadiosToggle.map(function (item) {
            return item.addEventListener("click", function (event) {
                var element = event.target;
                _this.sbcustomer = element.value;
                _this.toggleModifiers(event, ".js-sb-customer-acc-no");
            });
        });
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function (event) {
                return _this.closeForm("done");
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function (event) {
                return _this.closeForm("close");
            });
        }
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        this.relPartiesShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.relPartiesContent.removeAttribute("hidden");
            _this.relPartiesShowBtn.setAttribute("hidden", "true");
            _this.relPartiesHideBtn.removeAttribute("hidden");
        });
        this.relPartiesHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.relPartiesContent.setAttribute("hidden", "true");
            _this.relPartiesHideBtn.setAttribute("hidden", "true");
            _this.relPartiesShowBtn.removeAttribute("hidden");
        });
        this.element.querySelector('input[name=loan-amount]').addEventListener('input', function (e) {
            var value = e.target.value;
            if (value > MaxLoanAmount) {
                _this.validateLoanAmount("change");
            }
        });
    };
    FormItemBusinessSolarLoan.prototype.generateGuid = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    FormItemBusinessSolarLoan.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
        }
        else {
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
        window.location.href =
            "/southafrica/business/products-and-services/borrow-for-your-needs/business-loans/business-solar-loan";
    };
    FormItemBusinessSolarLoan.prototype.updateForm = function (pType) {
        if (this.sbAccountNumber) {
            var _group = this.sbAccountNumber.closest(".form__group");
            if (pType !== "YES") {
                this.sbAccountNumber.classList.remove("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
            else {
                this.sbAccountNumber.classList.remove("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
        }
    };
    FormItemBusinessSolarLoan.prototype.validate = function (fields) {
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.type != 'hidden') {
                this.validateEmptyTrustOtherEntity(field);
            }
        }
    };
    FormItemBusinessSolarLoan.prototype.validateEmptyTrustOtherEntity = function (fieldBusReg) {
        //debugger;
        this.emptyerrors = [];
        var format = /[-`~!@#$%^&*()_+=\[\]{};:"\\|,<>?]/;
        if (fieldBusReg) {
            if (fieldBusReg.value.length === 0) {
                this.emptyerrors.push("This field is required");
                var form_group = $(fieldBusReg).closest(".form__group");
                form_group.addClass("form__group--error");
                this.addErrorMessage(fieldBusReg, this.emptyerrors);
            }
            else {
                if (fieldBusReg.name === 'business-reg-number-trust') {
                    if (fieldBusReg.value.length == 2) {
                        this.emptyerrors.push('Please enter a valid trust eg. IT1234/1234');
                        var form_group = $(fieldBusReg).closest(".form__group");
                        form_group.addClass("form__group--error");
                        this.addErrorMessage(fieldBusReg, this.emptyerrors);
                    }
                    else if (fieldBusReg.value.length > 2 && fieldBusReg.value.substring(0, 2).toUpperCase() !== 'IT') {
                        this.emptyerrors.push('Please enter a valid trust reg. number starting with IT');
                        var form_group = $(fieldBusReg).closest(".form__group");
                        form_group.addClass("form__group--error");
                        this.addErrorMessage(fieldBusReg, this.emptyerrors);
                    }
                }
                else if (format.test(fieldBusReg.value)) {
                    this.emptyerrors.push('Please remove special characters');
                    var form_group = $(fieldBusReg).closest(".form__group");
                    form_group.addClass("form__group--error");
                    this.addErrorMessage(fieldBusReg, this.emptyerrors);
                }
            }
            if (this.emptyerrors.length == 0) {
                var _parent = fieldBusReg.closest(".form__group");
                if (_parent) {
                    fieldBusReg.closest(".form__group").classList.remove("form__group--error");
                    var _errorDiv = _parent.querySelector(".form__group--error_message");
                    if (_errorDiv) {
                        _errorDiv.remove();
                    }
                }
            }
        }
    };
    FormItemBusinessSolarLoan.prototype.validateBusinessType = function (type) {
        var _this = this;
        // Business Reg Validations
        function dfcBusinessFormatBusinessReg(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = _stringLength - 1;
            var _check = event.substring(_newLength);
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(_check)) {
                if (event.length === 4) {
                    event = event += "/";
                }
                else if (event.length === 11) {
                    event = event += "/";
                }
                else if (event.length > 14) {
                    event = event.substring(0, 14);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpression(inputText) {
            var _check = inputText.split("/");
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                var _valid3 = true;
                if (_check.length === 3) {
                    var _seg1 = new RegExp("^/d{4}$");
                    var _seg2 = new RegExp("^/d{6}$");
                    var _seg3 = new RegExp("^/d{2}$");
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_seg3.test(_check[2])) {
                        _valid3 = false;
                    }
                    if (_valid1 && _valid2 && _valid3) {
                        return inputText;
                    }
                    else {
                        return "";
                    }
                }
                else {
                    return "";
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 4);
                var _secondCharacters = inputText.substring(5, 10);
                var _thirdCharacters = inputText.substring(11, 13);
                return (_firstcharacters +
                    "/" +
                    _secondCharacters +
                    "/" +
                    _thirdCharacters);
            }
            return "";
        }
        function deleteContent(event) {
            if (event.inputType !== "deleteContentBackward" &&
                event.inputType !== "deleteContentForward") {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessReg(reg);
            }
        }
        function addBlur(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpression(reg);
        }
        // Business Reg Validations
        function dfcBusinessFormatBusinessRegTrust(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = _stringLength - 1;
            var _check = event.substring(_newLength);
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(_check)) {
                if (event.length === 1) {
                    event = "IT" + event;
                }
                if (event.length === 6) {
                    event = event += "/";
                }
                else if (event.length > 11) {
                    event = event.substring(0, 11);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpressionTrust(inputText) {
            var _check = inputText.split("/");
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                if (_check.length === 2) {
                    var _seg1 = new RegExp("^/d{6}$");
                    var _seg2 = new RegExp("^/d{4}$");
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_valid1 && _valid2) {
                        return inputText;
                    }
                    else {
                        return "";
                    }
                }
                else {
                    return "";
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 6);
                var _secondCharacters = inputText.substring(7, 11);
                //const _thirdCharacters = inputText.substring(11, 13);
                return (_firstcharacters +
                    "/" +
                    _secondCharacters);
            }
            return "";
        }
        function deleteContentTrust(event) {
            if (event.inputType !== "deleteContentBackward" &&
                event.inputType !== "deleteContentForward") {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessRegTrust(reg);
            }
        }
        function addBlurTrust(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpressionTrust(reg);
        }
        if (this.businessType.value === "Private_Company" ||
            this.businessType.value === "Close_Corporation" ||
            this.businessType.value === "OtherContent" ||
            this.businessType.value === "Trust") {
            var fieldIdno = this.form.querySelector('input[name="id-number"]');
            var fieldBusReg = this.form.querySelector('input[name="business-reg-number"]');
            var fieldBusRegTrust = this.form.querySelector('input[name="business-reg-number-trust"]');
            var fieldBusRegOther = this.form.querySelector('input[name="business-reg-number-other"]');
            // const fieldBusReg: any = this.form.querySelector(
            // 	`input.form__input--business-registration`
            // );
            var field = void 0;
            if (fieldBusReg) {
                field = fieldBusReg;
            }
            else if (fieldIdno) {
                field = fieldIdno;
            }
            else if (fieldBusRegTrust) {
                field = fieldBusRegTrust;
            }
            else if (fieldBusRegOther) {
                field = fieldBusRegOther;
            }
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var errorMessage = formGroupItem.querySelector('.form__group--error_message');
                if (errorMessage) {
                    errorMessage.remove();
                }
                var labelItem = formGroupItem.querySelector("label");
                labelItem.innerText = "Business Registration Number";
                var newBusRegField = document.createElement("input");
                newBusRegField.setAttribute("name", "business-reg-number");
                newBusRegField.classList.remove("form__input--required");
                newBusRegField.classList.remove("form__input--busReg");
                newBusRegField.classList.remove("form__input--business-registration");
                newBusRegField.classList.add("form__input");
                newBusRegField.placeholder = "Enter your business registration number";
                if (this.businessType.value === "OtherContent") {
                    labelItem.innerText = "Registration Number";
                    newBusRegField.setAttribute("name", "business-reg-number-other");
                    newBusRegField.setAttribute("id", "business-reg-number-other");
                    newBusRegField.classList.add("form__input");
                    newBusRegField.classList.add("solarloan_busreg_other_input");
                    newBusRegField.placeholder = "Enter your registration number";
                    newBusRegField.addEventListener("blur", function (pEvent) {
                        _this.validateEmptyTrustOtherEntity(pEvent.currentTarget);
                    });
                }
                else if (this.businessType.value === "Trust") {
                    labelItem.innerText = "Trust Registration Number";
                    newBusRegField.value = "IT";
                    newBusRegField.setAttribute("name", "business-reg-number-trust");
                    newBusRegField.setAttribute("id", "business-reg-number-trust");
                    newBusRegField.classList.add("form__input");
                    newBusRegField.classList.add("solarloan_busreg_trust_input");
                    newBusRegField.placeholder = "Enter your trust registration number";
                    newBusRegField.addEventListener("blur", function (pEvent) {
                        _this.validateEmptyTrustOtherEntity(pEvent.currentTarget);
                    });
                    //newBusRegField.addEventListener(`input`, deleteContentTrust);
                    //newBusRegField.addEventListener(`blur`, addBlurTrust);
                }
                else {
                    newBusRegField.classList.add("form__input--required");
                    newBusRegField.classList.add("form__input--busReg");
                    newBusRegField.classList.add("form__input--business-registration");
                    // This adds slashes to the business registration number
                    newBusRegField.addEventListener("input", deleteContent);
                    newBusRegField.addEventListener("blur", addBlur);
                    newBusRegField.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                }
                field.parentNode.replaceChild(newBusRegField, field);
            }
        }
        else if (this.businessType.value === "Partnership" || this.businessType.value === "Sole_Proprietor") {
            // This removes event listener
            var fieldBusReg = this.form.querySelector('input[name="business-reg-number"]');
            var fieldIdno = this.form.querySelector('input[name="id-number"]');
            var fieldBusRegTrust = this.form.querySelector('input[name="business-reg-number-trust"]');
            var fieldBusRegOther = this.form.querySelector('input[name="business-reg-number-other"]');
            var field = void 0;
            if (fieldBusReg) {
                field = fieldBusReg;
            }
            else if (fieldIdno) {
                field = fieldIdno;
            }
            else if (fieldBusRegTrust) {
                field = fieldBusRegTrust;
            }
            else if (fieldBusRegOther) {
                field = fieldBusRegOther;
            }
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var errorMessage = formGroupItem.querySelector('.form__group--error_message');
                if (errorMessage) {
                    errorMessage.remove();
                }
                var labelItem = formGroupItem.querySelector("label");
                labelItem.innerText = "ID Number";
                var newIdField = document.createElement("input");
                newIdField.setAttribute("name", "id-number");
                newIdField.setAttribute("maxlength", "13");
                newIdField.classList.add("form__input");
                newIdField.classList.add("form__input--required");
                newIdField.classList.add("form__input--identification");
                if (this.businessType.value === "Partnership") {
                    newIdField.classList.remove("form__input--required");
                    newIdField.classList.remove("form__input--identification");
                }
                newIdField.placeholder = "Enter your South African ID number";
                newIdField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newIdField, field);
            }
        }
        else {
            //((this.businessType.value === `OtherContent`) || (this.businessType.value === `Trusts`)){
        }
    };
    FormItemBusinessSolarLoan.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet"));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (displayStep <= showStep) {
                    pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
                }
                else {
                    pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
                }
            });
            var _bulletLines = Array.from(this.bulletContainer.querySelectorAll(".form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link"));
            _bulletLines.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (showStep > displayStep) {
                    pItem.classList.add("form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link--active");
                }
                else {
                    pItem.classList.remove("form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link--active");
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        var _h3Heading = this.customHeading.querySelector("h3");
        if (_heading != null) {
            _h3Heading.innerHTML = _heading;
        }
        var _stepno = this.stepNo.querySelector("h6");
        if (_stepno != null) {
            _stepno.innerHTML = "STEP " + showStep + " OF 3";
        }
        window.scrollTo(0, 0);
    };
    FormItemBusinessSolarLoan.prototype.showNextStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
    };
    FormItemBusinessSolarLoan.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    FormItemBusinessSolarLoan.prototype.submitForm = function (form) {
        var _this = this;
        var _firstName = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _emailAddress = form.querySelector("input[name=email-address]");
        var _phoneNumber = form.querySelector("input[name=contact-number]");
        var _identificationNo = form.querySelector("input[name=identity-number]");
        var _businessRelation = form.querySelector("input[name=business-relation]");
        var _entityType = form.querySelector("select[name=business-type]");
        var _numberOfYearsTrading = form.querySelector("input[name=business-trade-years]");
        var _businessName = form.querySelector("input[name=business-name]");
        var _numberOfDirectors = form.querySelector("input[name=business-directors]");
        var _businessEmailAddress = form.querySelector("input[name=business-email-address]");
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var _businessOtherNumber = form.querySelector("input[name=business-reg-number-other]");
        var _businessTrustNumber = form.querySelector("input[name=business-reg-number-trust]");
        var _businessId = form.querySelector("input[name=id-number]");
        var _businessIndustry = form.querySelector("select[name=business-industry]");
        var _femaleOwnership = form.querySelector("input[name=female-ownership]"); //radio
        var _businessRegion = form.querySelector("select[name=business-region]");
        var _solarLeasingBusiness = form.querySelector("input[name=solar-leasing]");
        var _businessNature = form.querySelector("select[name=business-nature]");
        var _solarInstaller = form.querySelector("input[name=solar-installer]"); //radio
        var _authorityToApply = form.querySelector("input[name=permission-act]"); //radio
        var _legallyEnterContracts = form.querySelector("input[name=legal-contracts]"); //radio
        var _existingBounceBackLoan = form.querySelector("input[name=solar-loan]"); //radio
        var _debtReview = form.querySelector("input[name=debt-review]"); //radio
        var _loanAmount = form.querySelector("input[name=loan-amount]"); //radio
        var _purposeOfLoan = form.querySelector("select[name=loan-purpose]");
        var _standardBankCustomer = form.querySelector("input[name=existing-customer]"); //radio
        var _businessAccountNumber = form.querySelector("input[name=sb-account-number]");
        var _standardBankPreferredSupplier = form.querySelector("input[name=preferred-supplier]"); //radio
        var _personalMonthlyExpense = form.querySelector("input[name=personal-monthly-expenses]");
        var _personalMonthlyIncome = form.querySelector("input[name=personal-monthly-income]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        if (this.businessType.value === "Private_Company" || this.businessType.value === "Close_Corporation" || this.businessType.value === "Partnership") {
            this.companyRegistrationOrId = _businessRegNumber ? _businessRegNumber.value : "";
        }
        else if (this.businessType.value === "Trust") {
            this.companyRegistrationOrId = _businessTrustNumber ? _businessTrustNumber.value : "";
        }
        else if (this.businessType.value === "OtherContent") {
            this.companyRegistrationOrId = _businessOtherNumber ? _businessOtherNumber.value : "";
        }
        else {
            this.companyRegistrationOrId = _businessId ? _businessId.value : "";
        }
        var _businessIncome = this.getDataConsentValue(form, "bus-income");
        var _businessExpense = this.getDataConsentValue(form, "bus-expenses");
        var _businessMonthlyIncome;
        var _businessAnnualIncome;
        var _businessMonthlyExpenses;
        var _businessAnnualExpenses;
        if (_businessIncome) {
            if (_businessIncome === "YES") {
                _businessMonthlyIncome = form.querySelector("input[name=business-income]");
                _businessAnnualIncome = "";
            }
            else {
                _businessAnnualIncome = form.querySelector("input[name=business-income]");
                _businessMonthlyIncome = "";
            }
        }
        if (_businessExpense) {
            if (_businessExpense === "YES") {
                _businessMonthlyExpenses = form.querySelector("input[name=business-expenses]");
                _businessAnnualExpenses = "";
            }
            else {
                _businessAnnualExpenses = form.querySelector("input[name=business-expenses]");
                _businessMonthlyExpenses = "";
            }
        }
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (_date && _time) {
            //if (_time.value !== `Anytime`) {
            _dateTime = _date.value + " " + _time.value;
            //}
        }
        var _postData = {
            'firstName': (_firstName ? _firstName.value : ''),
            'lastName': (_surname ? _surname.value : ''),
            'saIdNumber': (_identificationNo ? _identificationNo.value : ''),
            'businessRelation': _businessRelation ? _businessRelation.value : "",
            'emailAddress': (_emailAddress ? _emailAddress.value : ''),
            'contactNumber': (_phoneNumber ? _phoneNumber.value : ''),
            'entityType': (_entityType ? _entityType.value : ''),
            'numberOfYearsTrading': (_numberOfYearsTrading ? _numberOfYearsTrading.value : ''),
            'businessName': (_businessName ? _businessName.value : ''),
            'numberOfDirectors': (_numberOfDirectors ? _numberOfDirectors.value : ''),
            'businessEmailAddress': (_businessEmailAddress ? _businessEmailAddress.value : ''),
            'companyRegistrationOrId': this.companyRegistrationOrId,
            'industry': (_businessIndustry ? _businessIndustry.value : ''),
            'femaleOwnership': ((_femaleOwnership ? (_femaleOwnership.checked ? "YES" : "NO") : "NO")),
            'businessDescription': '',
            'solarLeasingBusiness': ((_solarLeasingBusiness ? (_solarLeasingBusiness.checked ? "YES" : "NO") : "NO")),
            'businessRegion': (_businessRegion ? _businessRegion.value : ''),
            'solarInstaller': ((_solarInstaller ? (_solarInstaller.checked ? "YES" : "NO") : "NO")),
            'natureOfBusiness': (_businessNature ? _businessNature.value : ''),
            'authorityToApply': ((_authorityToApply ? (_authorityToApply.checked ? "YES" : "NO") : "NO")),
            'legallyEnterContracts': ((_legallyEnterContracts ? (_legallyEnterContracts.checked ? "NO" : "YES") : "YES")),
            'loanAmount': (_loanAmount ? _loanAmount.value.replaceAll(' ', '') : ''),
            'purposeOfLoan': (_purposeOfLoan ? _purposeOfLoan.value : ''),
            'existingBounceBackLoan': ((_existingBounceBackLoan ? (_existingBounceBackLoan.checked ? "YES" : "NO") : "NO")),
            'debtReview': ((_debtReview ? (_debtReview.checked ? "YES" : "NO") : "NO")),
            'standardBankCustomer': ((_standardBankCustomer ? (_standardBankCustomer.checked ? "YES" : "NO") : "NO")),
            'businessAccountNumber': (_businessAccountNumber ? _businessAccountNumber.value : ''),
            'standardBankPreferredSupplier': ((_standardBankPreferredSupplier ? (_standardBankPreferredSupplier.checked ? "YES" : "NO") : "NO")),
            'personalMonthlyIncome': (_personalMonthlyIncome ? _personalMonthlyIncome.value : ''),
            'personalMonthlyExpense': (_personalMonthlyExpense ? _personalMonthlyExpense.value : ''),
            'bestTimeToCall': _dateTime,
            'businessMonthlyIncome': (_businessMonthlyIncome ? _businessMonthlyIncome.value : ''),
            'businessAnnualIncome': (_businessAnnualIncome ? _businessAnnualIncome.value : ''),
            'businessMonthlyExpense': (_businessMonthlyExpenses ? _businessMonthlyExpenses.value : ''),
            'businessAnnualExpense': (_businessAnnualExpenses ? _businessAnnualExpenses.value : ''),
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(form, 'data-sharing-email'),
            'dataSharingSms': this.getDataConsentValue(form, 'data-sharing-sms'),
            'dataSharingInApp': 'YES'
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/business-solar-loan";
        // config
        var _config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // service
        this.formsService.postForm(url, _postData, _config)
            .then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code, false);
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage("step 4 success form");
                if (!_this.iSstep3Completed && !dataLayer.formisSubmitted)
                    _this.analyticsService.dtmFormComplete("complete", pResponse.code, true);
                _this.iSstep3Completed = true;
                _this.analyticsService.completeDtmApplication();
                _this.dtmVirtualPage("thank you");
                _this.showDisplayView("success");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessSolarLoan.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessSolarLoan.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 50, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayDecline.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "decline":
                this.displayDecline.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FormItemBusinessSolarLoan.prototype.dtmVirtualPage = function (pPageNameNew) {
        var taggingValue = pPageNameNew === 'thank you' ?
            'business:products and services:borrow for your needs:business loans:business solar loans  success thank you'
            : "business:products and services:borrow for your needs:business loans:business solar loan:" +
                pPageNameNew;
        dataLayer.pageName = taggingValue;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    FormItemBusinessSolarLoan.prototype.updatePageName = function (pageName) {
        dataLayer.pageName =
            "business:products and services:borrow for your needs:business loans:business solar loan:" +
                pageName;
    };
    FormItemBusinessSolarLoan.prototype.updateFormName = function () {
        var dataNewFormName = "business:products and services:borrow for your needs:business loans:business solar loan";
        this.analyticsService.dtmFormNameUpdate(dataNewFormName);
        this.analyticsService.dtmAllowFormRefresh();
    };
    FormItemBusinessSolarLoan.prototype.toggleModifiers = function (event, selector) {
        var targetModifier = this.element.querySelector(selector);
        var element = event.target;
        if (targetModifier) {
            //const field: any = this.form.querySelector('input[name="sb-account-number"]');
            if (element.value == "YES") {
                targetModifier.classList.remove("form-item-business-solar-loan__hidden");
                targetModifier.classList.add("form-item-business-solar-loan__active");
                // if (field) {
                // 	const formGroupItem: HTMLFormElement = field.closest(`.form__group`);
                // 	field.classList.add(`form__input`);
                // 	field.classList.add(`form__input--required`);
                // }
            }
            else {
                targetModifier.classList.remove("form-item-business-solar-loan__active");
                targetModifier.classList.add("form-item-business-solar-loan__hidden");
                // if (field) {
                // 	const formGroupItem: HTMLFormElement = field.closest(`.form__group`);
                // 	formGroupItem.classList.remove(`form__group--error`);
                // 	field.classList.remove(`form__input`);
                // 	field.classList.remove(`form__input--required`);
                // }
            }
        }
    };
    return FormItemBusinessSolarLoan;
}(Base));
export { FormItemBusinessSolarLoan };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-business-solar-loan/form-item-business-solar-loan.component.ts
// module id = 1041
// module chunks = 0